<template>
	<div class="step_bar">
		<div class="content">
			<ul class="title_box">
				<li v-for="(item, index) in step_bar" :key="index">
					<div class="imgBox">
						<img :src="'/imgs/wayToStudy/analysis_test/step/' + (index < step ? item.overImgUrl : item.imgUrl)" alt="">
						<div :class="index == (step-1) ? 'green_line' : 'white_line'"></div>
					</div>
					<p :class="index < step ? 'title' : ''">
						{{item.title}}
					</p>
				</li>
			</ul>
		</div>
	</div>       
</template>
<style type="text/css" lang='less' scoped>
.step_bar {
	width: 100%;
	margin: 10px 0;
	.content {
		width: 930px;
		margin: 0 auto;
		padding-top: 20px;
		.title_box {
			padding-bottom: 10px;
			// height: 36px;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			padding-right: 11px;
			li {
				// width: 110px;
				    flex: .9;
					background: url(/imgs/wayToStudy/analysis_test/step/title_repeat.png);
					background-repeat: no-repeat;
					background-position: 125px 32px;
				.imgBox {
					// width: 110px;
					height: 60px;
					text-align: center;
				}
				p {
					line-height: 36px;
					font-size: 16px;
					color: #666;
					font-weight: 600;
					text-align: center;
				}
				.title {
					color: #3187e6;
				}
			}
			li:nth-child(2),li:nth-child(3),li:nth-child(4){
				background-repeat:repeat-x;
				background-position: 131px 32px;
				
			}
			li:nth-child(5){
				width: 150px;
                flex: 0.7;
				background-repeat:no-repeat;
				background-position: 0 32px;
			}
		}
	}
}
</style>
<script>
export default {
    props: [ 'step' ],
    data() {
        return {
        	step_bar: [
        		{ title: '基本信息', imgUrl: 'icon_white1_1.png',overImgUrl: 'icon_blue1_1.png' },
        		{ title: '身体条件', imgUrl: 'icon_white2_1.png',overImgUrl: 'icon_blue2_1.png' },
        		{ title: '家庭条件', imgUrl: 'icon_white3_1.png',overImgUrl: 'icon_blue3_1.png' },
        		{ title: '个人能力', imgUrl: 'icon_white4_1.png',overImgUrl: 'icon_blue4_1.png' },
        		{ title: '个人意愿', imgUrl: 'icon_white5_1.png',overImgUrl: 'icon_blue5_1.png' },
        	]
        }
    },
    methods: {
    },
    watch: {
    },
    created() {
    },
    mounted() {
       
    }
}
</script>
